module.exports = __webpack_public_path__ + "media/gili/coffee_maker-02d6ff64.jpg";